import type { AssetHydrationQuery } from '../contexts';
import type { HydrateScrolledAssetsQueryVariables } from '../gql/generated/HydrateScrolledAssets';
import type { HydrateScrolledShareAssetsQueryVariables } from '../gql/generated/HydrateScrolledShareAssets';

/** Only the scrolled query carries `visibleFieldIds`. */
type PossibleQueries =
  | HydrateScrolledAssetsQueryVariables
  | HydrateScrolledShareAssetsQueryVariables;

export const getVisibleFieldIds = (
  query: AssetHydrationQuery<PossibleQueries>
) => {
  const visibleFieldIds = query.variables?.visibleFieldIds;
  return Array.isArray(visibleFieldIds) ? visibleFieldIds : undefined;
};
